<template>
	<div class="job-teacher-page">
		<!-- 页面标题 -->
		<div class="page-header">
			<div class="title-line">
				<span class="line"></span>
				<span class="title">任课教师</span>
				<el-button style="margin-left: 10px;" @click="toBatch()">批量设置</el-button>
			</div>
		</div>

		<!-- 年级切换 -->
		<div class="grade-tabs">
			<span v-for="grades in gradeList" :key="grades.grade" class="grade-tab"
				:class="{ active: currentGrade === grades.grade }" @click="selectGrade(grades.grade)">
				{{ grades.gradeName }}
			</span>
			
		</div>
		<div class="table-wrap">
		<el-table :data="classList" border style="width: 100%; " class="job-table">
			<el-table-column prop="name" label="班级" align="center" />
			<el-table-column prop="areaName" label="校区" align="center" />
			<!-- 班主任 -->
			<el-table-column label="班主任" align="center">
				<template slot-scope="scope">
					<el-button type="text" @click="openSetDialog(scope.row.id, 0, 8)">
						{{ getTeacher(scope.row.id, 0, 8) || '设置' }}
					</el-button>
				</template>
			</el-table-column>

			<!-- 副班主任 -->
			<el-table-column label="副班主任" align="center">
				<template slot-scope="scope">
					<el-button type="text" @click="openSetDialog(scope.row.id, 0, 9)">
						{{ getTeacher(scope.row.id, 0, 9) || '设置' }}
					</el-button>
				</template>
			</el-table-column>

			<!-- 学科 -->
			<el-table-column v-for="sub in subjectList.filter(v=>v.value!=0)" :key="sub.value" :label="sub.label" align="center">
				<template slot-scope="scope">
					<el-button type="text" @click="openSetDialog(scope.row.id, sub.value, 10)">
						{{ getTeacher(scope.row.id, sub.value, 10) || '设置' }}
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		</div>

		<!-- 设置教师弹窗 -->
		<el-dialog title="设置任课教师" :visible.sync="dialogVisible" width="550px"  append-to-body="true"
		  	:loading="dialogLoading">
			<!-- 搜索下拉 -->
			<el-select
				v-model="selectedTeacherId"
				placeholder="请选择教师"
				filterable
				remote
				:remote-method="searchTeacher"
				style="width: 100%; margin-bottom: 15px;"
				clearable
			>
				<el-option
					v-for="teacher in teacherList"
					:key="teacher.id"
					:label="teacher.name"
					:value="teacher.id"
				></el-option>
			</el-select>

			<!-- 已选教师 -->
			<div v-if="selectedTeacherId" style="padding: 10px; background: #f7f8fa; border-radius: 6px;">
				已选教师：<b>{{ getSelectedName() }}</b>
				<el-button type="success" size="mini" @click="saveTeacher" style="margin-left: 10px;">
					确认保存
				</el-button>
			</div>

			<!-- 当前任职列表 & 可删除 -->
			<div style="margin-top: 15px;">
				<div style="font-weight: bold; margin-bottom: 8px;">当前任职：</div>
				<el-tag
					v-for="item in currentAssignList"
					:key="item.id"
					type="primary"
					closable
					@close="deleteAssign(item.id)"
					style="margin-right: 8px; margin-bottom: 8px;"
				>
					{{ item.teacherName }}
				</el-tag>
				<div v-if="currentAssignList.length === 0" style="color: #999;">暂无任职</div>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">关闭</el-button>
			</div>
		</el-dialog>
		<el-dialog 
		  title="批量设置" 
		  :visible.sync="isBatch" 
		  width="80%" 
		  center
		  :close-on-click-modal="false"
		  custom-class="batch-setting-dialog"
		  :show-close="true"
		  append-to-body="true"
		  	:loading="dialogLoading"
		>
		  <!-- 核心：子组件专属包裹层，宽高100%适配弹窗，完全禁止外层滚动，滚动权交给子组件 -->
		  <div class="child-component-wrapper">
		    <NewTeacher 
		      :gradeList="gradeList" 
		      :grade="currentGrade"  
		      @close="closeBatch" 
		    />
		  </div>
		</el-dialog>
			
		
	</div>
</template>

<script>
	import { teacherSubject } from "@/js/standard.js";
	import NewTeacher from "./newTeacher.vue"
	import * as XLSX from 'xlsx';
	export default {
		
		name: "JobTeacher",
		components:{
			NewTeacher
		},
		data() {
			return {
				gradeList: [],
				currentGrade: null,
				classList: [],
				subjectList: [],
				teacherMap: {},
				dialogVisible: false,
				dialogClassId: null,
				dialogSubjectId: null,
				dialogRoleType: null,
				teacherList: [],
				selectedTeacherId: null,
				schoolId: localStorage.getItem('orgId'),
				currentAssignList: [], // 当前任职列表
				login:null,
				subjectLists:[],
				isBatch:false,
				dialogLoading:false,
			};
		},
		created() {
			this.forSubject();
			
		},
		methods: {
			closeBatch(val){
				
				this.isBatch=false
				if(val){
					this.forSubject()
				}
			},
			toBatch(){
				this.isBatch=true
			},
			loginOpen(text) {
			  this.login = this.$loading({
			    lock: true,
			    text: text,
			    zIndex: 100001,
			    spinner: 'el-icon-loading',
			    background: 'rgba(0, 0, 0, 0.7)'
			  });
			},
			noLogin(){
			  if(this.login){
			    this.login.close()
			    this.login = null;
			  }
			},
			// 学科
			async forSubject() {
				if(this.subjectLists.length==0){
					this.subjectLists =await teacherSubject();
					this.forgradeList();
				}else{
					this.forgradeList();
				}
				
			},

			// 年级
			forgradeList() {
				this.loginOpen('年级加载中...')
				this.API.get(this.API.school.getSchoolGrad, {
					schoolId: this.schoolId
				}).then(res => {
					console.log('res.data.data',res.data.data)
					this.gradeList = res.data.data;
					this.noLogin()
					if (this.gradeList.length > 0) {
						
						this.selectGrade(this.gradeList[0].grade);
						
					}
				}).catch(()=>{
					this.noLogin()
				})
			},

			// 选择年级
			selectGrade(id) {
				this.loginOpen('任职加载中...')
				this.isBatch=false
				this.currentGrade = id;
				var tage=id<7?1:id<10?2:3
				this.subjectList=this.subjectLists.filter(v=>!v.stageCode||v.stageCode==tage)
				this.forClsasList(id);
				this.loadAllAssign(id);
			},

			// 班级
			forClsasList(id) {
				this.API.get(this.API.school.getSchoolGradClass, {
					schoolId: this.schoolId,
					gradeId: id
				}).then(res => {
					this.classList = res.data.data.map(v => ({
						...v,
						name: v.classAlias
					}))
				}).catch(()=>{
					this.noLogin()
				})
			},

			// 加载该年级所有任职（用于表格显示）
			loadAllAssign(gradeId) {
			  this.API.get(this.API.school.getAssignGrade+this.schoolId+'/' + gradeId).then(res => {
			    let list = res.data.data;
			    this.teacherMap = {};
			    list.forEach(item => {
			      let key = `${item.classId}_${item.subjectId}_${item.roleType}`;
			      // 核心修改：判断key是否存在，存在则拼接，不存在则赋值
			      if (this.teacherMap[key]) {
			        // 去重：避免重复拼接同一个教师名称
			        if (!this.teacherMap[key].includes(item.teacherName)) {
			          this.teacherMap[key] = `${this.teacherMap[key]}|${item.teacherName}`;
			        }
			      } else {
			        this.teacherMap[key] = item.teacherName;
			      }
			    });
				this.noLogin()
			  }).catch(()=>{
				  this.noLogin()
			  })
			},

			// 获取表格显示的教师名
			getTeacher(classId, subjectId, roleType) {
				let key = `${classId}_${subjectId}_${roleType}`;
				return this.teacherMap[key];
			},

			// 打开弹窗
			openSetDialog(classId, subjectId, roleType) {
				this.loginOpen('班级学科任职加载中...')
				this.dialogClassId = classId;
				this.dialogSubjectId = subjectId;
				this.dialogRoleType = roleType;
				this.selectedTeacherId = null;
				this.loadCurrentAssign(); // 加载当前任职
			},

			// 加载当前班级+学科+角色的任职列表
			loadCurrentAssign() {
				this.API.get(this.API.school.getAssignClass + this.dialogClassId).then(res => {
					
					let all = res.data.data;
					this.currentAssignList = all.filter(item =>
						item.subjectId == this.dialogSubjectId &&
						item.roleType == this.dialogRoleType
					);
					this.dialogVisible = true;
					this.noLogin()
				}).catch(()=>{
					this.noLogin()
				})
			},

			// 远程搜索教师
			searchTeacher(key) {
				this.loginOpen('教师查询中...')
				var name=key || ''
				this.API.get(this.API.school.getSchoolSearch, {
					pageNum: 1,
					pageSize: 100,
					schoolId: this.schoolId,
					name: name
				}).then(res => {
					
					this.teacherList = res.data.data.records;
					this.noLogin()
				}).catch(()=>{
					this.noLogin()
				})
			},

			// 获取选中的名字
			getSelectedName() {
				let t = this.teacherList.find(u => u.id == this.selectedTeacherId);
				return t ? t.name : "";
			},

			// 保存
			saveTeacher() {
				if (!this.selectedTeacherId) {
					return this.$message.warning("请选择教师");
				}
				this.loginOpen('班级任职设置中...')
				var gradeId=this.classList.filter(v=>v.id==this.dialogClassId)[0].gradeId
				let params = {
					userId: this.selectedTeacherId,
					classId: this.dialogClassId,
					subjectId: this.dialogSubjectId,
					roleType: this.dialogRoleType,
					schoolId:this.schoolId,
					gradeId:gradeId
				};
				this.API.post(this.API.school.postAssignSave, params).then((res) => {

					if(res.data.code==500){
						this.$message.success(res.data.msg);
						this.selectedTeacherId = null;
					}else{
						this.$message.success("设置成功");
						this.loadAllAssign(this.currentGrade);
						this.loadCurrentAssign();
						this.selectedTeacherId = null;
					}
					this.noLogin()
				}).catch(()=>{
					this.noLogin()
				})
			},

			// 删除任职
			deleteAssign(id) {
				this.loginOpen('班级任职取消中...')
				this.API.deleted(this.API.school.deletedAssign + id).then(() => {
					this.noLogin()
					this.$message.success("已取消任职");
					this.loadAllAssign(this.currentGrade);
					this.loadCurrentAssign();
				}).catch(()=>{
					this.noLogin()
				})
			}
		}
	};
</script>

<style scoped>
	
	.job-teacher-page {
		width: calc(60vw);
		padding: 15px;
	}

	.page-header {
		margin-bottom: 20px;
	}

	.title-line {
		display: flex;
		align-items: center;
		margin-bottom: 8px;
	}

	.line {
		display: inline-block;
		width: 3px;
		height: 16px;
		background-color: #1e88e5;
		margin-right: 8px;
	}

	.title {
		font-size: 14px;
		font-weight: bold;
		color: #333;
	}

	.grade-tabs {
		margin-bottom: 15px;
	}

	.grade-tab {
		display: inline-block;
		padding: 0 8px;
		margin-right: 10px;
		font-size: 14px;
		cursor: pointer;
		color: #666;
	}

	.grade-tab.active {
		color: #1e88e5;
		font-weight: 500;
	}

	.job-table /deep/ th {
		background-color: #1e88e5;
		color: #fff;
	}

	/deep/ .el-button--text {
		color: #1e88e5;
	}
	/* 教师按钮文本省略 */
	.teacher-btn {
	  max-width: 100%;
	  display: inline-block;
	  overflow: hidden;
	  text-overflow: ellipsis;
	  white-space: nowrap;
	  vertical-align: middle;
	}
	.job-teacher-page {
	    padding: 15px;
	    height: calc(100vh - 60px);
	    display: flex;
	    flex-direction: column;
	}
	
	.grade-tabs{
	    flex-shrink:0; /*标签固定高度不压缩*/
	}
	.table-wrap{
	    flex:1;
	    overflow: auto; /*内容超出自动出横竖滚动条*/
		max-width: 80%;
	}
	/*美化滚动条*/
	.table-wrap::-webkit-scrollbar{width:6px;height:6px;}
	.table-wrap::-webkit-scrollbar-thumb{background:#ccc;border-radius:3px;}
	/* 核心：弹窗固定视窗居中，适配屏幕尺寸，完全禁止自身滚动 */
	/deep/ .batch-setting-dialog {
	  margin: 0 !important;
	  position: fixed !important;
	  top: 50% !important;
	  left: 50% !important;
	  transform: translate(-50%, -50%) !important;
	  max-height: 90vh !important; /* 弹窗最大高度不超过视窗90%，上下留安全边距 */
	  width: 80% !important;
	  display: flex !important;
	  flex-direction: column !important;
	  overflow: hidden !important; /* 核心：弹窗整体完全禁止滚动 */
	}
	
	/* 核心：弹窗内容区域，100%适配弹窗，完全禁止滚动，所有滚动权交给子组件 */
	/deep/ .batch-setting-dialog .el-dialog__body {
	  padding: 0 !important; /* 去掉内边距，让子组件完全占满内容区域 */
	  flex: 1 !important;
	  width: 100% !important;
	  height: 100% !important;
	  overflow: hidden !important; /* 核心：彻底禁止弹窗内容区域的滚动 */
	}
	
	/* 核心：子组件包裹层，宽高100%适配弹窗，完全把滚动控制权交给子组件内部 */
	.child-component-wrapper {
	  width: 100%;
	  height: 100%;
	  margin: 10px;
	  overflow: hidden; /* 外层完全禁止滚动，子组件内部自己控制 */
	}
</style>